"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchConfig = void 0;
// Proxy to lazily resolve config on first property access,
// avoiding process.env evaluation at module load time
function resolveMatchConfig() {
    var _a;
    // Fallback logic for local development, injected through webpack
    var env = {};
    try {
        env = process.env;
    }
    catch (_b) {
        // process is not defined (pilet bundle in browser)
    }
    var envDefaults = {
        BASE_URL: env.BASE_URL || '',
        BASE_API_URL: env.BASE_API_URL || '',
        NEXT_PUBLIC_URL: env.NEXT_PUBLIC_URL || '',
        SIGNIN_PAGE_URL: env.SIGNIN_PAGE_URL || '',
        AUTH0_API_URL: env.AUTH0_API_URL || '',
        AUTH0_IMS_API_URL: env.AUTH0_IMS_API_URL || '',
        OE_API_WS_URL: env.OE_API_WS_URL || '',
        COOKIE_DOMAIN: env.COOKIE_DOMAIN || '',
        ACCOUNT_COOKIE_DOMAIN: env.ACCOUNT_COOKIE_DOMAIN || '',
        LANGUAGE_COOKIE_DOMAIN: env.LANGUAGE_COOKIE_DOMAIN || '',
        MONITORING_LINK: env.MONITORING_LINK || '',
        FF_ENV: env.FF_ENV || 'local',
        GUIDE_DOC_URL: env.GUIDE_DOC_URL || '',
        AUTH0_DOMAIN_URL: env.AUTH0_DOMAIN_URL || '',
        SUPPORT_PAGE_URL: env.SUPPORT_PAGE_URL || '',
        AIRWALLEX_ENV: env.AIRWALLEX_ENV || 'demo',
        TARGET_ENV: env.TARGET_ENV || '',
        DISABLE_CREDIT_CARD: env.DISABLE_CREDIT_CARD === 'true',
        FF_API: env.FF_API || '',
        FF_ENVIRONMENT_ID: env.FF_ENVIRONMENT_ID || ''
    };
    // Runtime config injected via window.__APP_CONFIG__ (entrypoint.sh / Next.js SSR).
    // Spread envDefaults first so any fields absent from an older entrypoint.sh image
    // receive safe defaults rather than silently returning undefined.
    if (typeof window !== 'undefined' &&
        ((_a = window.__APP_CONFIG__) === null || _a === void 0 ? void 0 : _a.BASE_URL)) {
        return __assign(__assign({}, envDefaults), window.__APP_CONFIG__);
    }
    return envDefaults;
}
exports.matchConfig = new Proxy({}, {
    get: function (_target, prop) {
        return resolveMatchConfig()[prop];
    },
    has: function (_target, prop) {
        return prop in resolveMatchConfig();
    },
    ownKeys: function () {
        return Reflect.ownKeys(resolveMatchConfig());
    },
    getOwnPropertyDescriptor: function (_target, prop) {
        return Object.getOwnPropertyDescriptor(resolveMatchConfig(), prop);
    }
});
